module.exports = __webpack_public_path__ + "static/media/wk-dash.7690ccf8.svg";